import { Form } from "antd";
import React, { useEffect, useState } from "react";
import BaseInput from "../../components/form/BaseInput";
import { ContentWrapped } from "./style";
import SaveButton from "../../components/button/saveButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getTermsPageContentRequest,
  postTermsPageContentRequest,
} from "../../redux/contentManagementSlice";
import Loading from "../../components/shared/GeneralComponents";
import { BannerImage, CONTENT_PAGES, STATUSES } from "../../config/constants/defaultValues";
import TextAreas from "../../components/form/TextAreas";
import SeoSection from "../../components/shared/seoSection";

const TermsPage = () => {
  const dispatch = useDispatch();
  const { termsPageData, termsPageStatus, termsPageError } = useSelector(
    (state) => state.contentManagement
  );
  const [form] = Form.useForm();

  //Seo Section states
  const [ogImageUrl, setOGImageUrl] = useState();
  const [ogImageFile, setOGImageFile] = useState();
  const [twitterImageUrl, setTwitterImageUrl] = useState();
  const [twitterImageFile, setTwitterImageFile] = useState();

  useEffect(() => {
    dispatch(getTermsPageContentRequest(CONTENT_PAGES.TERMS_PAGE));
  }, [dispatch]);

  useEffect(() => {
    if (termsPageData) {
      form.setFieldsValue({
        "detail[bannerSection][heading]": termsPageData?.contentPage?.detail?.bannerSection?.heading,
        "detail[bannerSection][description]":termsPageData?.contentPage?.detail?.bannerSection?.description,
        "detail[innerSection][firstHeading]": termsPageData?.contentPage?.detail?.innerSection?.firstHeading,
        "detail[innerSection][firstDescription]": termsPageData?.contentPage?.detail?.innerSection?.firstDescription,
        "detail[innerSection][secondHeading]": termsPageData?.contentPage?.detail?.innerSection?.secondHeading,
        "detail[innerSection][secondDescription]": termsPageData?.contentPage?.detail?.innerSection?.secondDescription,
        "detail[innerSection][thirdHeading]": termsPageData?.contentPage?.detail?.innerSection?.thirdHeading,
        "detail[innerSection][thirdDescription]": termsPageData?.contentPage?.detail?.innerSection?.thirdDescription,
        "detail[innerSection][forthHeading]": termsPageData?.contentPage?.detail?.innerSection?.forthHeading,
        "detail[innerSection][forthDescription]": termsPageData?.contentPage?.detail?.innerSection?.forthDescription,
        "detail[innerSection][fifthHeading]": termsPageData?.contentPage?.detail?.innerSection?.fifthHeading,
        "detail[innerSection][fifthDescription]": termsPageData?.contentPage?.detail?.innerSection?.fifthDescription,
        "detail[innerSection][sixHeading]": termsPageData?.contentPage?.detail?.innerSection?.sixHeading,
        "detail[innerSection][sixDescription]": termsPageData?.contentPage?.detail?.innerSection?.sixDescription,
        "detail[innerSection][sevenHeading]": termsPageData?.contentPage?.detail?.innerSection?.sevenHeading,
        "detail[innerSection][sevenDescription]": termsPageData?.contentPage?.detail?.innerSection?.sevenDescription,
        "detail[innerSection][eightHeading]": termsPageData?.contentPage?.detail?.innerSection?.eightHeading,
        "detail[innerSection][eightDescription]": termsPageData?.contentPage?.detail?.innerSection?.eightDescription,
        "detail[innerSection][nineHeading]": termsPageData?.contentPage?.detail?.innerSection?.nineHeading,
        "detail[innerSection][nineDescription]": termsPageData?.contentPage?.detail?.innerSection?.nineDescription,
      //Seo Values Set
      meta_title: termsPageData?.contentPage?.seo_keywords?.meta_title ?? "",
      meta_description: termsPageData?.contentPage?.seo_keywords?.meta_description ?? "",
      is_canonical: termsPageData?.contentPage?.seo_keywords?.is_canonical === 1 ? true : false,
      robots_meta: termsPageData?.contentPage?.seo_keywords?.robots_meta ?? "",
      meta_author: termsPageData?.contentPage?.seo_keywords?.meta_author ?? "",
      og_type: termsPageData?.contentPage?.seo_keywords?.og_type ?? "",
      og_title: termsPageData?.contentPage?.seo_keywords?.og_title ?? "",
      og_description: termsPageData?.contentPage?.seo_keywords?.og_description ?? "",
      og_image_width: termsPageData?.contentPage?.seo_keywords?.og_image_width ?? "",
      og_image_height: termsPageData?.contentPage?.seo_keywords?.og_image_height ?? "",
      og_url: termsPageData?.contentPage?.seo_keywords?.og_url ?? "",
      og_site_name: termsPageData?.contentPage?.seo_keywords?.og_site_name ?? "",
      og_locale: termsPageData?.contentPage?.seo_keywords?.og_locale ?? "",
      og_locale_alternate: termsPageData?.contentPage?.seo_keywords?.og_locale_alternate ?? "",
      twitter_card: termsPageData?.contentPage?.seo_keywords?.twitter_card ?? "",
      twitter_site: termsPageData?.contentPage?.seo_keywords?.twitter_site ?? "",
      twitter_title: termsPageData?.contentPage?.seo_keywords?.twitter_title ?? "",
      twitter_description: termsPageData?.contentPage?.seo_keywords?.twitter_description ?? "",
      twitter_url: termsPageData?.contentPage?.seo_keywords?.twitter_url ?? "",
    });
    setTwitterImageUrl(termsPageData?.contentPage?.seo_keywords?.twitter_image ?? BannerImage);
    setOGImageUrl(termsPageData?.contentPage?.seo_keywords?.og_image ?? BannerImage);
    }
  }, [termsPageData]);

  const onUpdate = (values) => {
    const data={
      ...values,
      name:'Terms and Conditions',
      "og_image": ogImageFile ?? "",
      "twitter_image": twitterImageFile ?? "",
      "is_canonical": values.is_canonical === true ? 1 : 0,
      _method: 'PUT'
    }
    dispatch(postTermsPageContentRequest({data,id:termsPageData?.contentPage?.id})) 
  };
  return (
    <>
    {termsPageStatus === STATUSES.LOADING ? (
      <Loading />
    ) : termsPageError === STATUSES.ERROR ? (
      <div>{termsPageError}</div>
    ) : (
      <ContentWrapped>
        <div className="row">
          <div className="col-sm-12">
            <Form
              layout="vertical"
              className="pt-3"
              form={form}
              onFinish={onUpdate}
            >
              <div className="row">
                <div className="col-sm-12 d-flex justify-content-between align-items-start mb-4">
                  <h3 className="font-bold" >Terms and Conditions</h3>
                  <SaveButton title="Update" />
                </div>
              </div>
              <div className="row">
              <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12">
                  {/* Banner Section */}
                  {/* <HeadingTitle title="Banner Section" /> */}
                  <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Banner Section Heading"
                      name="detail[bannerSection][heading]"
                      placeText="Banner Section Heading"
                    />
                    <TextAreas
                      labelText="Banner Section Description"
                      name="detail[bannerSection][description]"
                      placeText="Banner Section Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section First Heading"
                      name="detail[innerSection][firstHeading]"
                      placeText="Inner Section First Heading"
                    />
                    <TextAreas
                      labelText="Inner Section First Description"
                      name="detail[innerSection][firstDescription]"
                      placeText="Inner Section First Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Second Heading"
                      name="detail[innerSection][secondHeading]"
                      placeText="Inner Section Second Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Second Description"
                      name="detail[innerSection][secondDescription]"
                      placeText="Inner Section Second Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Third Heading"
                      name="detail[innerSection][thirdHeading]"
                      placeText="Inner Section Third Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Third Description"
                      name="detail[innerSection][thirdDescription]"
                      placeText="Inner Section Third Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Forth Heading"
                      name="detail[innerSection][forthHeading]"
                      placeText="Inner Section Forth Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Forth Description"
                      name="detail[innerSection][forthDescription]"
                      placeText="Inner Section Forth Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Fifth Heading"
                      name="detail[innerSection][fifthHeading]"
                      placeText="Inner Section Fifth Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Fifth Description"
                      name="detail[innerSection][fifthDescription]"
                      placeText="Inner Section Fifth Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Six Heading"
                      name="detail[innerSection][sixHeading]"
                      placeText="Inner Section Six Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Six Description"
                      name="detail[innerSection][sixDescription]"
                      placeText="Inner Section Six Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Seven Heading"
                      name="detail[innerSection][sevenHeading]"
                      placeText="Inner Section Seven Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Seven Description"
                      name="detail[innerSection][sevenDescription]"
                      placeText="Inner Section Seven Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Eight Heading"
                      name="detail[innerSection][eightHeading]"
                      placeText="Inner Section Eight Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Eight Description"
                      name="detail[innerSection][eightDescription]"
                      placeText="Inner Section Eight Description"
                    />
                    <BaseInput
                      inputIcon={<i className="bi bi-pencil icon_style"></i>}
                      labelText="Inner Section Nine Heading"
                      name="detail[innerSection][nineHeading]"
                      placeText="Inner Section Nine Heading"
                    />
                    <TextAreas
                      labelText="Inner Section Nine Description"
                      name="detail[innerSection][nineDescription]"
                      placeText="Inner Section Nine Description"
                    />
                </div>
                <SeoSection ogImageUrl={ogImageUrl}
                  setOGImageFile={setOGImageFile}
                  setOGImageUrl={setOGImageUrl}
                  twitterImageUrl={twitterImageUrl}
                  setTwitterImageFile={setTwitterImageFile}
                  setTwitterImageUrl={setTwitterImageUrl} />
              </div>

            </Form>
          </div>
        </div>
      </ContentWrapped>
    )}
  </>
);
};

export default TermsPage;
